export class VerifiyOldKioskPinCode {
    userAdditionalDataId;
    oldKioskPinIdToVerify;

    constructor(userAdditionalDataId = '', oldKioskPinIdToVerify = '') {
        this.userAdditionalDataId = userAdditionalDataId;
        this.oldKioskPinIdToVerify = oldKioskPinIdToVerify;
    };
};